/* eslint-disable react/display-name */

import { memo, useState } from 'react';

import { Button, DateCell, dateTimeFormatter, formattedCell } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { Datepicker, HookFormResolver } from '@dec/shared';
import { type HookFormMethods } from '@dec/shared';
import { BtnGroup, BtnToolbar, Col, Row } from '@dec/shared';
import { type ColDef, type ValueFormatterParams } from 'ag-grid-community';
import { ActionsGrid } from 'app/components/grid';
import { type ActionColumn } from 'app/components/grid/actions-column';
import GridApplication from 'app/components/grid/gridApplication';
import { baseUrl } from 'app/modules/Taxpayer/TaxpayerRequestEvaluation/services/taxpayerRequestEvaluation.service';
import {
  type TaxpayerRequestPaginatedResponse,
  type TaxpayerRequestParams
} from 'app/modules/Taxpayer/TaxpayerRequestEvaluation/types';
import * as Icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { StringParam, useQueryParams } from 'use-query-params';

const idWithoutData = '01660e23-d782-40f3-9c67-6c0537f64aa9';
interface Props {}

export const TaxpayerHistory = memo((props: Props) => {
  const [parameters, setParameters] = useQueryParams({
    id: StringParam,
    tin: StringParam,
    name: StringParam
  });
  const navigate = useNavigate();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();

  const [search, setSearch] = useState<any>({
    requestState: 'approved',
    taxpayerId: parameters?.id ? parameters?.id : idWithoutData
  });

  const onSearch = (values: TaxpayerRequestParams) => {
    //  values.taxpayerRequestType = values.taxpayerRequestType?.id;
    setSearch({ RequestState: 'approved', id: parameters?.id, ...values });
  };

  const actions: Array<ActionColumn> = [
    {
      icon: Icon.Search,
      variant: 'secondary',
      onClick: (row: TaxpayerRequestPaginatedResponse) => {
        navigate('/taxpayer/history/' + row.id, { state: { requestType: row.requestType } });
      }
    }
  ];

  const colDef: Array<ColDef> = [
    {
      headerName: t('common.label.actions'),
      cellRenderer: ActionsGrid,
      cellRendererParams: {
        actions: actions
      }
    },
    { headerName: t('taxpayer-request-val.label.request'), field: 'requestNumber' },
    {
      headerName: t('taxpayer-request-val.label.type'),
      field: 'requestType',
      valueFormatter: (params: ValueFormatterParams) => {
        return t(`common.taxpayer-request-types.${params.value}`);
      }
    },
    {
      headerName: t('taxpayer-request-val.label.taxpayer'),
      field: 'taxpayerName'
    },
    {
      headerName: t('taxpayer-request-val.label.state'),
      field: 'requestStatus',
      valueFormatter: (params: ValueFormatterParams) => {
        return t(`common.taxpayer-request-states.${params.value}`);
      }
    },
    {
      headerName: t('taxpayer-request-val.label.createdDate'),
      field: 'createdDate',
      ...formattedCell(dateTimeFormatter, DateCell)
    }
  ];

  return (
    <>
      <h1>
        {parameters.tin} - {parameters.name}
      </h1>
      <HookFormResolver onSubmit={onSearch} initialValues={{}}>
        {({ formState: { errors }, reset, setValue, control }: HookFormMethods) => {
          return (
            <>
              <Row>
                <Col>
                  <Datepicker
                    label={t('taxpayer-request-val.label.date-from')}
                    name="requestFrom"
                  />
                </Col>
                <Col>
                  <Datepicker label={t('taxpayer-request-val.label.date-to')} name="requestTo" />
                </Col>
              </Row>
              {/*<Row>*/}
              {/*  <Col>*/}
              {/*    <Combobox*/}
              {/*      code="id"*/}
              {/*      display="name"*/}
              {/*      data={taxpayerRequestTypesCollection()}*/}
              {/*      label={label(t, 'request-type')}*/}
              {/*      name="taxpayerRequestType"*/}
              {/*    />*/}
              {/*  </Col>*/}
              {/*</Row>*/}
              <BtnToolbar>
                <BtnGroup>
                  <Button
                    action={ButtonAction.return}
                    type={'button'}
                    onClick={() => {
                      navigate(-1);
                    }}
                  />
                  <Button
                    action={ButtonAction.clean}
                    variant={'secondary'}
                    type={'button'}
                    onClick={() => {
                      setValue('requestFrom', undefined);
                      setValue('requestTo', undefined);
                      reset();
                      setSearch({ requestState: 'approved', taxpayerId: parameters?.id });
                    }}
                  />
                </BtnGroup>
                <BtnGroup>
                  <Button action={ButtonAction.find} type={'submit'} variant={'primary'} />
                </BtnGroup>
              </BtnToolbar>
            </>
          );
        }}
      </HookFormResolver>
      <hr></hr>
      <Row>
        <Col>
          <GridApplication url={baseUrl} columnDefs={colDef} search={search} />
        </Col>
      </Row>
    </>
  );
});
